import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsLocation from './components/Settings/SettingsLocation'
import OnboardStep from './components/Onboard/OnboardStep'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class OnboardLocationContainer extends Component {

  render() {
    return <OnboardStep pathname="/onboard/finish" save={true} {...this.props}>
      <SettingsLocation {...this.props} />
    </OnboardStep>
  }

}

export default connect((state) => ({ settings: state.onboard }), mapDispatchToProps)(OnboardLocationContainer)
